import { OrderedMap, Record } from 'immutable';

export const mkFeatureFlagsStore = Record({
  featureFlags: OrderedMap(),
  resourceName: 'FEATURE_FLAGS',
  loadPending: true,
  isLoading: false,
  error: undefined,
});

export const FEATURE_FLAGS_REDUCER_KEY = 'featureFlagsStore';
